<template>
  <StaticFormHolder
    :form-name="formName"
    :gtm-form-name="gtmFormName"
    is-dialog
    :steps-before="stepsBefore"
  />
</template>

<script>
export default {
  name: 'DashboardTallyTestForm',
  props: {
    formName: {
      type: String,
      required: true
    },
    gtmFormName: {
      type: String,
      required: false
    },
    internalName: {
      type: String,
      required: true
    },
    testIcon: {
      type: String,
      required: true
    }
  },
  computed: {
    evaluationId() {
      return this.$store.state.staticForms.tally[this.internalName].infoStep.evaluationId;
    },
    iframeQueryString() {
      const params = new URLSearchParams({
        profile_id: this.$auth.user.profileId,
        test_name: this.internalName,
        uuid: this.evaluationId
      });

      return params.toString();
    },
    iframeLink() {
      if (!this.evaluationId) {
        return null;
      }
      return `${this.$t(
        `tally.${this.internalName}.urls.${this.$auth.user?.benefit?.active ? 'b2b' : 'b2c'}`,
        this.$auth.user.language
      )}?${this.iframeQueryString}`;
    },
    stepsBefore() {
      return [
        {
          cmp: 'TallyInfoStep',
          dialogDataStore: `staticForms/tally/${this.internalName}/infoStep`,
          props: {
            internalName: this.internalName,
            testIcon: this.testIcon
          }
        },
        {
          cmp: 'IframeStep',
          dialogDataStore: `staticForms/tally/${this.internalName}/iframeStep`,
          props: {
            iframeLink: this.iframeLink
          }
        }
      ];
    }
  },
  watch: {
    '$auth.user.language': function () {
      this.setForm();
    },
    evaluationId: function () {
      this.setForm(true);
    }
  },
  created() {
    this.setForm();
  },
  methods: {
    setForm(preserveStep = false) {
      this.$store.dispatch('dynamicForms/setForm', {
        formName: this.formName,
        data: { formType: 'static' },
        stepsBefore: this.stepsBefore,
        updateRouteOnCreate: false,
        preserveStep
      });
    }
  }
};
</script>
